import cn from 'classnames';
import { HTMLAttributes, ReactNode } from 'react';
import Balancer from 'react-wrap-balancer';

export interface HeadingDescriptionProps
	extends HTMLAttributes<HTMLHeadingElement> {
	testId?: string;
	children: ReactNode;
}

const HeadingDescription = (props: HeadingDescriptionProps) => {
	const {
		testId = 'HeadingDescription',
		children,
		className,
		...rProps
	} = props;

	return (
		<p
			data-testid={testId}
			className={cn(
				`mx-auto mb-12 mt-3 max-w-5xl text-center text-base font-medium text-slate-500
				lg:text-xl lg:tracking-tighter`,
				className,
			)}
			{...rProps}
		>
			<Balancer>{children}</Balancer>
		</p>
	);
};

export default HeadingDescription;
